import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../utils/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { getCurrentVolunteer, isVolunteerAuthenticated, logoutVolunteer } from '../api/volunteerAuthService';
import { syncPushToken, onForegroundMessage } from '../api/fcmService';

const VolunteerAuthContext = createContext();

export function useVolunteerAuth() {
  return useContext(VolunteerAuthContext);
}

export function VolunteerAuthProvider({ children }) {
  const [currentVolunteer, setCurrentVolunteer] = useState(null);
  const [loading, setLoading] = useState(true);

  const isVolunteerPath = (pathname) => pathname.includes('/volunteer/');

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) setLoading(true);
      try {
        if (user) {
          const isVol = await isVolunteerAuthenticated();
          if (isVol) {
            const volunteer = await getCurrentVolunteer();
            setCurrentVolunteer(volunteer);
            // Re-capture this browser's latest push token on every sign-in (silent, no permission dialog).
            if (volunteer?.subscriptionPreferences?.pushNotifications !== false) {
              syncPushToken('volunteer', { prompt: false });
            }
          } else {
            if (isVolunteerPath(window.location.pathname)) setCurrentVolunteer(null);
          }
        } else {
          if (isVolunteerPath(window.location.pathname)) setCurrentVolunteer(null);
        }
      } catch (err) {
        console.error('VolunteerAuthContext error:', err);
        if (isVolunteerPath(window.location.pathname)) setCurrentVolunteer(null);
      } finally {
        setLoading(false);
      }
    });
    const stopForeground = onForegroundMessage();
    return () => { unsubscribe(); stopForeground(); };
  }, []);

  const handleLogout = async () => {
    try {
      setCurrentVolunteer(null);
      await logoutVolunteer();
      return true;
    } catch (err) {
      throw err;
    }
  };

  const value = { currentVolunteer, loading, logout: handleLogout };

  return (
    <VolunteerAuthContext.Provider value={value}>
      {children}
    </VolunteerAuthContext.Provider>
  );
}
